import { createStructuredSelector, createSelector } from 'reselect'
import { momentTimeYear } from '../../../../Utils/DateLocalizationHelper'

export const avgBatteryCycleCard = state => state.dashboard.batteryAbove
export const batteriesProperties = (state) => state.user?.subscription?.batteriesProperties || [];
export const currentCulture = state => state.user.language

export const data = createSelector(
  [avgBatteryCycleCard, currentCulture, batteriesProperties],
  (avgBatHp, culture, batteriesProps) => 
    {
    const batteryList = avgBatHp.getIn(['batteryList'], []);
    const filteredList = batteryList.filter(value => {
      if (!batteriesProps || batteriesProps.length === 0) {
        return value.batteryPercentage >= 50 && 
              value.cycleCount <= 500 && 
              (value.batteryAge === null || value.batteryAge <= 30);
      }
      
      let shouldInclude = true;
      
      if (batteriesProps.includes('batteryPercentage')) {
        shouldInclude = shouldInclude && value.batteryPercentage >= 50;
      }
      
      if (batteriesProps.includes('cycleCount')) {
        shouldInclude = shouldInclude && value.cycleCount <= 500;
      }
      
      if (batteriesProps.includes('batteryAge')) {
        shouldInclude = shouldInclude && (value.batteryAge === null || value.batteryAge <= 30);
      }
      
      return shouldInclude;
    });
    
    return filteredList.map((row, index) => {
      const hour = momentTimeYear(row.calculatedManufactureDate, culture.slice(0, 2));
      let resultObj;
      if (Array.isArray(batteriesProps) && batteriesProps.length === 0) {
        resultObj = {
          serialNumber: row.serialNumber,
          batteryAge: row.batteryAge,
          batteryPercentage: row.batteryPercentage,
          cycleCount: row.cycleCount,
          currentDevice: row.currentDevice,
          currentDeviceAlias: row.currentDeviceAlias,
          calculatedManufactureDate: hour,
          deviceSite: row.deviceSite,
          batterySite: row.batterySite,
          lastUpdated: row.lastUpdated
        };
      } else {
        const result = {};
        batteriesProps.forEach(prop => {
          switch (prop) {
            case 'batteryPercentage':
              result.batteryPercentage = row.batteryPercentage;
              break;
            case 'cycleCount':
              result.cycleCount = row.cycleCount;
              break;
            case 'batteryAge':
              result.batteryAge = row.batteryAge;
              break;
            default:
              result[prop] = row[prop];
              break;
          }
        });

        resultObj = {
          serialNumber: row.serialNumber,
          currentDevice: row.currentDevice,
          currentDeviceAlias: row.currentDeviceAlias,
          calculatedManufactureDate: hour,
          deviceSite: row.deviceSite,
          batterySite: row.batterySite,
          lastUpdated: row.lastUpdated,
          ...result
        };
      }
      return resultObj;
    });
  }
)

export const loading = createSelector(
  [avgBatteryCycleCard],
  avgBatHp => avgBatHp.getIn(['loading'], false)
)

export default createStructuredSelector({
  data,
  loading,
})
